// src/components/ui/GlowButton.js
// Bouton "premium" Maxula : dégradé magenta de marque, halo lumineux et
// reflet animé au survol. Rendu robuste (styles en ligne + 1 keyframe injecté),
// indépendant de la version de Tailwind. Peut rendre un <button>, un <Link>
// (prop `to`) ou un <a target=_blank> (prop `href`).
// Maxula

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const STYLE_ID = 'mx-glowbtn-style';
function injectOnce() {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = [
    '@keyframes mxGlowSheen{0%{transform:translateX(-130%) skewX(-18deg)}60%,100%{transform:translateX(340%) skewX(-18deg)}}',
    '.mx-glowbtn{position:relative;overflow:hidden;isolation:isolate}',
    '.mx-glowbtn .mx-sheen{position:absolute;top:0;left:0;height:100%;width:38%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.5),transparent);transform:translateX(-130%) skewX(-18deg);pointer-events:none}',
    '.mx-glowbtn:hover .mx-sheen{animation:mxGlowSheen .9s ease}',
  ].join('');
  document.head.appendChild(el);
}

const GRADIENTS = {
  magenta: 'linear-gradient(135deg,#E11D79 0%,#FF3D9A 52%,#FF77BC 100%)',
  green: 'linear-gradient(135deg,#059669 0%,#10B981 52%,#34D399 100%)',
};
const GLOW = {
  magenta: '225,29,121',
  green: '16,185,129',
};

export default function GlowButton({
  children, icon: Icon, onClick, to, href,
  variant = 'magenta', size = 'md', className = '', title,
}) {
  useEffect(injectOnce, []);

  const pad = size === 'sm' ? 'px-4 py-2 text-sm' : 'px-5 py-2.5 text-sm';
  const rgb = GLOW[variant] || GLOW.magenta;
  const baseShadow = `0 8px 22px -8px rgba(${rgb},.6), inset 0 1px 0 rgba(255,255,255,.3)`;
  const hoverShadow = `0 14px 30px -6px rgba(${rgb},.8), inset 0 1px 0 rgba(255,255,255,.45)`;
  const style = { background: GRADIENTS[variant] || GRADIENTS.magenta, boxShadow: baseShadow };

  const onEnter = (e) => { e.currentTarget.style.boxShadow = hoverShadow; e.currentTarget.style.transform = 'translateY(-1px)'; };
  const onLeave = (e) => { e.currentTarget.style.boxShadow = baseShadow; e.currentTarget.style.transform = 'none'; };

  const cls = `mx-glowbtn inline-flex items-center justify-center gap-2 rounded-full font-semibold text-white select-none transition-transform duration-200 active:scale-[0.97] ${pad} ${className}`;
  const inner = (
    <>
      <span className="mx-sheen" aria-hidden="true" />
      <span className="relative inline-flex items-center gap-2" style={{ zIndex: 1 }}>
        {Icon ? <Icon size={size === 'sm' ? 15 : 17} /> : null}
        {children}
      </span>
    </>
  );
  const shared = { className: cls, style, title, onMouseEnter: onEnter, onMouseLeave: onLeave };

  if (to) return <Link to={to} {...shared}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" {...shared}>{inner}</a>;
  return <button type="button" onClick={onClick} {...shared}>{inner}</button>;
}
